/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material
import Button from 'material/ctas/button/button_container';
// utils
import { isContentValid } from 'utils/embeds/content_validation';
// styles
// import injectSheet from 'react-jss';
// import styles from 'material/ctas/newcontent/newcontent_styles';



/* ========== ~~~~~~~~~~ CTA : NEW CONTENT ~~~~~~~~~~ ========== */
// STATELESS FUNCTIONAL COMPONENT
// used to create markup structure and render UI
// doesn't need all the lifecycle functions attached
const NewContentCTA = (props) => {
	function handleClick(e) {
		e.preventDefault();
		if(isContentValid(props.selectedContent)) {
			props.addContent('quiz')
			//props.updateNoLiveContent(false)
		} else {
            props.invalidateSelectedContent();
            props.sendMessage('There are required fields you must fill out before continuing.');
        }
	}
    return(
    	<Button type={`custom`} handleClick={handleClick} variant={`primary`} name={`newcontent`} text={`Add Page +`} />
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default NewContentCTA;
// export default injectSheet(styles)(NewContentCTA);